import { OnInit } from '@angular/core';
var RatingComponent = /** @class */ (function () {
    function RatingComponent() {
        this.MAX_RATING = 5;
        this.showExact = false;
    }
    Object.defineProperty(RatingComponent.prototype, "setRating", {
        set: function (rating) {
            this.rating = rating;
            this.ratingArray = new Array(this.MAX_RATING).fill(null).map(function (_, index) {
                var roundDiff = Math.round((rating - index) * 2) / 2;
                return roundDiff >= 1 ? 'star' : roundDiff === 0.5 ? 'star_half' : 'star_border';
            });
        },
        enumerable: true,
        configurable: true
    });
    RatingComponent.prototype.ngOnInit = function () {
    };
    return RatingComponent;
}());
export { RatingComponent };
